package com.appcreator.blueprint.conditions

import com.appcreator.blueprint.core.Condition
import kotlinx.serialization.Serializable

@Serializable
data object UnsupportedCondition: Condition